import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';
const AboutUsPage = () => {
    useEffect(() => {
        document.title = ":: About Us | Adber Infra India Pvt. Ltd. ::";
    }, []);
    return (
        <div>
            <Header />
            <section className="inner-page-banner-area why">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> About Adber Infra </h1>
                                <p> One of the established RMC suppliers in Pune.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/"> Home </Link></li>
                        <li> About Adber Infra </li>
                    </ol>
                </div>
            </div>
            <div className="container" id="InternalPageArea">
                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Core Purpose, Vision & Core Values </h3>
                    </div>
                </div>
                <div className="row visionmissnOuter text-center wow fadeIn">
                    <div className="col-md-4 col-sm-6 col-xs-12 text-center">
                        <div className="media visionBox grn">
                            <div className="media-left">
                                <a href="#">
                                    <img className="media-object" src="../assets/images/icon/mission.png" alt="Core Purpose" title="Core Purpose" />
                                </a>
                            </div>
                            <div className="media-body">
                                <h2> Core Purpose </h2>
                                <p> To help our customers by giving quality products and services to build their visions. </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-6 col-xs-12 text-center">
                        <div className="media missionBox">
                            <div className="media-left">
                                <a href="#">
                                    <img className="media-object" src="../assets/images/icon/vision.png" alt="Vision" title="Vision" />
                                </a>
                            </div>

                            <div className="media-body">
                                <h2> Our Vision </h2>
                                <p> To be No. 1 Leader in Pune Region by having 8% market share by 2028.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-xs-12 text-center">
                        <div className="media valueBox value">
                            <div className="media-left">
                                <a href="#">
                                    <img className="media-object" src="../assets/images/icon/core-values.png" alt="Mission" title="Mission" />
                                </a>
                            </div>

                            <div className="media-body orange">
                                <h2> Core Values </h2>
                                <ul>
                                    <li> Integrity </li>
                                    <li> Responsibility </li>
                                    <li> Continues Hard Work and Self Improvement </li>
                                    <li> Respect to all Individuals</li>
                                    <li> Quality and Services</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-xs-12">
                        <p> Adber Infra India Pvt. Ltd. have established easy solutions of Captive RMC Plants on site to provide economical and low cost in construction for the clients and also various Commercial plants in and around Maharashtra. Being a highly effective, lean and fast-moving organization, we are highly instrumental in providing an extensive array of Ready Mix Concrete. The offered concrete is processed using the finest quality raw material and ultra-modern technology in adherence with industry norms. Our provided mix concrete is tested on varied parameters of quality so as to offer a pure grade to our client's. </p>

                        <p> Adber Infra India Pvt. Ltd. is a top player in the category Ready Mix Concrete manufacturing and services in the Pune. This well-known establishment acts as a one-stop destination serving customers both local and from other parts of Pune. Over the course of its journey, this business has established a firm foothold in its industry. The belief that customer satisfaction is as important as their products and services, have helped this establishment garner a vast base of customers, which continues to grow by the day. This business employs individuals that are dedicated towards their respective roles and put in a lot of effort to achieve the common vision and larger goals of the company. In the near future, this business aims to expand its line of products and services and cater to a larger client base. In Pune and Maharashtra, this establishment occupies a prominent location in Undri. It is an effortless task in commuting to this establishment as there are various modes of transport readily available.  </p>

                        <span className="tagline1"> Formerly known as Suyash RMC and it was merged in Adber Infra India Pvt. Ltd. on 1<sup>st </sup> July 2018. </span>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default AboutUsPage;

